export default "__VITE_ASSET__ZDx9h6Kc__"